import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-payroll-process-details-menu',
  templateUrl: './payroll-process-details-menu.component.html',
  styleUrls: ['./payroll-process-details-menu.component.css']
})
export class PayrollProcessDetailsMenuComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/hrms/payroll/payroll-process-details/payroll-process-details-menu/payroll-process-details-menu.component.ts